
















































import Vue, { PropType } from "vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import NavigationButton from "@/components/NavigationButton.vue";
import SyncStatusBadge from "../SyncStatusBadge.vue";
import DateTimeDisplay from "@/components/DateTimeDisplay.vue";
import PartnerInfo from "../detailViews/PartnerInfo.vue";
import IfaceSyncPartnerDTO from "../../models/IfaceSyncPartnerDTO";
import { Iface } from "../../models/Iface";
import store from "../../services/InterfaceStore";
import { t } from "@/plugins/i18n";

interface Props {
  /** Csoportosító külső azonosító (a fejlécben és a search-en is ezt használja) */
  extCode: string;
  /** Az aktuális partner rekord (kompakt összegzéshez) */
  partner: IfaceSyncPartnerDTO | null;
}

interface Computed {
  verkPartnerId: number;
  url: string;
  apiSearchName: string;
  columns: any[];
}

export default Vue.extend<{}, {}, Computed, Props>({
  name: "PartnerHistory",

  components: {
    ApiSearchPage,
    NavigationButton,
    SyncStatusBadge,
    DateTimeDisplay,
    PartnerInfo,
  },

  props: {
    extCode: { type: String, default: "" },
    partner: { type: Object as PropType<IfaceSyncPartnerDTO | null>, default: null },
  },

  computed: {
    /** Verk (felfelé irány): a külső kód a felküldésig üres, ezért ott a belső partner azonosító (mlgenpartner.szam) a kulcs (0 = nem az) */
    verkPartnerId(): number {
      return store.selectedInterface === Iface.Verk && this.partner && this.partner.partner > 1 ? this.partner.partner : 0;
    },

    url(): string {
      return this.verkPartnerId > 0
        ? `iface-sync-partner/history-search-partner/${store.selectedInterface}/${this.verkPartnerId}`
        : `iface-sync-partner/history-search/${store.selectedInterface}/${encodeURIComponent(this.extCode)}`;
    },

    apiSearchName(): string {
      return this.verkPartnerId > 0 ? `PartnerHistoryApiSearch_partner_${this.verkPartnerId}` : `PartnerHistoryApiSearch_${this.extCode}`;
    },

    columns(): any[] {
      return [
        { field: "id", title: "", width: 45, filterable: false, sortable: false, cell: "command" },
        { field: "updDateTime", title: t("Interface_Idopont"), width: 110, filterable: false, cell: "updDateTime" },
        { field: "syncStatusName", title: t("Statusz"), width: 140, cell: "syncStatusName" },
        { field: "name", title: t("Nev"), cell: "disabledText" },
        { field: "taxaccount", title: t("Adoszam"), width: 140, cell: "disabledText" },
        { field: "euTaxaccount", title: t("Interface_EUAdoszam"), width: 140, cell: "disabledText" },
        { field: "city", title: t("Varos"), width: 130, cell: "disabledText" },
        { field: "address", title: t("Cim"), cell: "disabledText" },
        { field: "errorText", title: t("Hibauzenet"), width: 200, cell: "disabledText" },
        { field: "syncRemark", title: t("Megjegyzes"), width: 180, cell: "disabledText" },
        { field: "updUserName", title: t("Interface_Modositotta"), width: 130, cell: "disabledText" },
      ];
    },
  },
});
